var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MainContent,{attrs:{"title":'Crear evento'}},[_c('div',{staticClass:"tw:max-w-7xl tw:mx-auto"},[_c(_setup.FormEvento,{attrs:{"evento":_setup.evento,"loading":_setup.loading,"errorsPeticion":_setup.errorsPeticion},on:{"terminado":_setup.crearEvento}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }